// Hardcoded filter options for the listing search. Deliberately not fetched
// from an endpoint: bounds, housingTypes, radiusOptions and popularPlaces are
// fixed by acceptance criteria (WHN-2097/2102) and maintained here.

export const filterConfig = {
  bounds: {
    price: { min: 185000, max: 1250000 },
    m2: { min: 0, max: 175 },
    perceel: { min: 0, max: 500 }
  },
  // Fixed set of 9 (WHN-2097/2102, renamed in WHN-2147 to the vocabulary the
  // sales portal moves to). slug is the filter name, and it is what the web
  // API's `types` param takes; the mapping onto the raw Pimcore housingKind
  // spellings behind each filter lives in the backend (App\Request\
  // HousingTypeFilter), so the data mess stays in one place. A link from before
  // the rename carries 'types=Rijwoning', which is no longer a filter name and
  // is dropped by criteriaContract: the type filter falls away, the rest of the
  // link keeps working.
  housingTypes: [
    { slug: 'Appartement', label: 'Appartement' },
    { slug: 'Bouwkavel', label: 'Bouwkavel' },
    { slug: 'Hoekwoning', label: 'Hoekwoning' },
    { slug: 'Toekomstgerichte hoekwoning', label: 'Toekomstgerichte hoekwoning' },
    { slug: 'Toekomstgerichte tussenwoning', label: 'Toekomstgerichte tussenwoning' },
    { slug: 'Toekomstgerichte tweekapper', label: 'Toekomstgerichte tweekapper' },
    { slug: 'Tussenwoning', label: 'Tussenwoning' },
    { slug: 'Tweekapper', label: 'Tweekapper' },
    { slug: 'Vrijstaand', label: 'Vrijstaand' }
  ],
  radiusOptions: [10, 25, 50],
  // Exactly 3, slugs are authoritative (must match the search backend).
  // Whoon still has to supply the definitive 3 (plan 60, open item 3).
  popularPlaces: [
    { slug: 's-hertogenbosch', label: "'s-Hertogenbosch", region: 'Noord-Brabant', aliases: ['den bosch'], lon: 5.304, lat: 51.699 },
    { slug: 'rosmalen', label: 'Rosmalen', region: 'Noord-Brabant', lon: 5.367, lat: 51.717 },
    { slug: 'eindhoven', label: 'Eindhoven', region: 'Noord-Brabant', lon: 5.469, lat: 51.441 }
  ],
  nearby: { label: 'In de buurt', region: 'Jouw omgeving', lon: 5.34, lat: 51.7 }
};

export const HOUSING_TYPE_SLUGS = filterConfig.housingTypes.map((type) => type.slug);
